import React, { Component } from 'react';
import Firebase from 'firebase';
import { Redirect } from 'react-router-dom'

class createForm extends Component {
    constructor() {
        super();
        this.state = {
            id: "",
            name: "",
            done: false
        }
        this.setFirebase = this.setFirebase.bind(this);
    }


    componentWillMount() {
        var newPostKey = Firebase.database().ref().child('forms').push().key;
        this.setState({ id: newPostKey });
    }


    setFirebase() {
        var draftRef = Firebase.database().ref('draft');
        var id = this.state.id;
        draftRef.child(id).set({
            "client_id": localStorage.client_id,
            "created_at": Firebase.database.ServerValue.TIMESTAMP,
            "name": this.state.name,
            "version": 1,
            "published": true,
            "datasets": [],
            "GPS": true,
            "pages": [{
                "elements": [{
                    "element_id": "LABEL",
                    "id": "TITLE_1",
                    "order": 0,
                    "style": {
                        "color": "#111111",
                        "size": "h2",
                        "style": "",
                        "type": "bold"
                    },
                    "text": "Checklist",
                    "visible": true
                }, {
                    "element_id": "SECTION",
                    "id": "SECTION_9",
                    "text": "Formulario de prueba",
                    "visible": true,
                    "style": {
                        color: "#111111",
                        backgroundColor: "#FFFFFF"
                    },
                }],
                "title": ""
            }]
        }).then(resp => {
            var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
            var regId = Firebase.database().ref().child('log').push().key;
            logRef.child(regId).set({
                admin: localStorage.email,
                timestamp: Firebase.database.ServerValue.TIMESTAMP,
                action: "add",
                target: {
                    type: "form",
                    id: this.state.id,
                    name: this.state.name
                }
            });
            this.setState({ done: true })
        });
    }

    render() {
        switch (this.state.done) {
            case false:
                return (
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-group">
                                <label htmlFor="name">Nuevo Formulario:</label>
                                <input type="text" className="form-control" id="name"
                                    placeholder="nombre del nuevo formulario"
                                    value={this.state.name}
                                    onChange={(e) => { this.setState({ name: e.target.value }) }}
                                />
                            </div>
                            <div className="form-group text-right">
                                {
                                    this.state.name ? <a className="btn btn-success" onClick={() => { this.setFirebase() }} >Crear</a> : ""
                                }
                            </div>
                        </div>
                    </div>
                );
            case true:
                return (
                    <Redirect to={"/editor/"+this.state.id} />
                )
        }
    }
}
export default createForm;



// WEBPACK FOOTER //
// ./src/views/newForms/createForm.js